/**
 * Global .js file
 */

import {
  // dummyAjaxCall,
  handleMenu,
  handleFancybox,
  initAccordions,
  initReviewsSlider,
  handleNewsletterForm,
  animateWhenVisible
} from './functions/app-functions';

document.addEventListener("DOMContentLoaded", () => {
  handleFancybox();
  handleMenu();
  initAccordions();
  initReviewsSlider();
});

window.onload = () => {
  handleNewsletterForm();
  // dummyAjaxCall('testvar1v2', 'testvar2v2');
  if (typeof LEXO_Captcha !== 'undefined') {
		LEXO_Captcha.initialise_all_forms();
	}

  setTimeout(function () {
    document.querySelector('body').classList.add('loaded');
  }, 150);
};

var resizeEnd;
window.onresize = () => {
  clearTimeout(resizeEnd);
  resizeEnd = setTimeout(() => {

  }, 200);
};

window.onscroll = () => {

};
